// Constants
import { ITEM_OPTION, VALUE_ADD_TO_WATCHLIST, VALUE_NOTES, } from 'SecuritiesApp/ts/constants/security-header-dropdown.constants';
/** Initial setup for the Action dropdown menu */
export const ACTION_DROPDOWN_CONFIG = {
    title: { label: 'Actions', icon: 'icon-dots-more' },
    list: [
        {
            type: ITEM_OPTION,
            label: 'Notes',
            value: VALUE_NOTES,
            icon: 'icon-notes',
            disabled: false,
        },
        {
            type: ITEM_OPTION,
            label: 'Add to Watchlist',
            value: VALUE_ADD_TO_WATCHLIST,
            icon: 'icon-add',
            disabled: false,
        },
    ],
};
export const SCHWAB_LOGO = 'securities/images/schwab-logo.svg';
